import React, { createContext, useCallback, useEffect, useState } from 'react'
import Users from './Users'
import { queryOptions, useQuery, useQueryClient } from '@tanstack/react-query'
import { queryClient as qc } from 'keys'
import { getAffiliationsTeamFetch, getUsersFetch } from 'store/middlewares/user.crud'
import { getAffiliationsFetch } from 'store/middlewares/affiliation.crud'
import { initialPage, initialPageSize } from 'keys/pagination'

const UsersPage = (props) => {
    const [userFilters, setUserFilters] = useState({})
    const [page, setPage] = useState(initialPage)
    const [pageSize, setPageSize] = useState(initialPageSize)
    const [sorting, setSorting] = useState([])
    const [searchVal, setSearchVal] = useState("")
    const [rowOpen, setRowOpen] = useState(null);
    const [data, setData] = useState(null)
    const queryClient = useQueryClient()

    const roles = queryClient.getQueryData([qc.roles])

    const affiliations = useQuery({
        queryKey: [qc.affiliations],
        refetchIntervalInBackground: false,
        queryFn: async () => {
            const { data } = await getAffiliationsFetch({ page, pageSize, search: searchVal, sorting, model: qc.users })
            return data
        }
    })

    const usersOptions = queryOptions({
        queryKey: [qc.users, page, pageSize, sorting, searchVal],
        queryFn: async () => {
            const { data } = await getUsersFetch({ page, pageSize, search: searchVal, sorting, model: qc.users })
            return data
        }
    })
    const users = useQuery(usersOptions)

    const user = useQuery({
        queryKey: [qc.user, rowOpen, 'users-screen'],
        queryFn: async () => {
            const params = {
                custom_user: rowOpen
            }
            const { data } = await getAffiliationsTeamFetch(params)
            return data
        },
        enabled: !!rowOpen
    })

    const onCollapse = useCallback((id, rowIndex) => {
        setData(null)
    }, [])

    useEffect(() => {
        if (!affiliations.data && !affiliations.isLoading)
            affiliations.refetch()
    }, [])

    const commonValue = {
        userFilters, setUserFilters,
        roles,
        user,
        users,
        usersOptions,
        affiliations,
        page, setPage,
        pageSize, setPageSize,
        sorting, setSorting,
        searchVal, setSearchVal,
        rowOpen, setRowOpen,
        data, setData,
        onCollapse
    }

    return (
        <UsersContext.Provider value={commonValue}>
            <Users {...props} />
        </UsersContext.Provider>
    )
}
export const UsersContext = createContext()
export default UsersPage